import React from 'react';
import Accordion from './Accordion';

const GEOMETRY_TYPES = {
  TOMOGRAPHY: 'tomography',
  INCLINED_LAMINOGRAPHY: 'inclined_laminography',
  COPLANAR_LAMINOGRAPHY: 'coplanar_laminography',
  GIMBAL_LOCK_LAMINOGRAPHY: 'gimbal_lock_laminography',
};

function GeometrySelector({ value, onChange }) {
  return (
    <div className="form-section geometry-selector">
      <Accordion title="Geometry" defaultOpen={true}>
        <div className="form-group">
          <label>Setup</label>
          <select value={value} onChange={(e) => onChange(e.target.value)}>
            <option value={GEOMETRY_TYPES.TOMOGRAPHY}>
              Tomography
            </option>
            <option value={GEOMETRY_TYPES.INCLINED_LAMINOGRAPHY}>
              Inclined Laminography
            </option>
            <option value={GEOMETRY_TYPES.COPLANAR_LAMINOGRAPHY}>
              Coplanar Laminography
            </option>
            <option value={GEOMETRY_TYPES.GIMBAL_LOCK_LAMINOGRAPHY}>
              Gimbal Lock Laminography
            </option>
          </select>
        </div>
      </Accordion>
    </div>
  );
}

export { GEOMETRY_TYPES };
export default GeometrySelector;
